import { render, staticRenderFns } from "./ExamAttrSetting.vue?vue&type=template&id=60aadbae&scoped=true&"
import script from "./ExamAttrSetting.vue?vue&type=script&lang=js&"
export * from "./ExamAttrSetting.vue?vue&type=script&lang=js&"
import style0 from "./ExamAttrSetting.vue?vue&type=style&index=0&id=60aadbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aadbae",
  null
  
)

export default component.exports